// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"4701": "7a38faa0","546": "e27fb529","7916": "1d381851",}[chunkId] + ".css"
}